import { t } from '@luna/i18n';

export type ShortMonthNames =
    | 'JAN'
    | 'FEB'
    | 'MAR'
    | 'APR'
    | 'MAY'
    | 'JUN'
    | 'JUL'
    | 'AUG'
    | 'SEP'
    | 'OCT'
    | 'NOV'
    | 'DEC';

type WeekDaySuffix = 'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT' | 'SUN';

export const SHORT_MONTH_NAMES: ShortMonthNames[] = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
];

const WEEK_DAY_SUFFIXES: WeekDaySuffix[] = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

const MONTH_NAME_MAP: Record<ShortMonthNames, () => string> = {
    JAN: () => t('months.month_JAN'),
    FEB: () => t('months.month_FEB'),
    MAR: () => t('months.month_MAR'),
    APR: () => t('months.month_APR'),
    MAY: () => t('months.month_MAY'),
    JUN: () => t('months.month_JUN'),
    JUL: () => t('months.month_JUL'),
    AUG: () => t('months.month_AUG'),
    SEP: () => t('months.month_SEP'),
    OCT: () => t('months.month_OCT'),
    NOV: () => t('months.month_NOV'),
    DEC: () => t('months.month_DEC'),
};

const SHORT_MONTH_NAME_MAP: Record<ShortMonthNames, () => string> = {
    JAN: () => t('monthsShort.month_JAN'),
    FEB: () => t('monthsShort.month_FEB'),
    MAR: () => t('monthsShort.month_MAR'),
    APR: () => t('monthsShort.month_APR'),
    MAY: () => t('monthsShort.month_MAY'),
    JUN: () => t('monthsShort.month_JUN'),
    JUL: () => t('monthsShort.month_JUL'),
    AUG: () => t('monthsShort.month_AUG'),
    SEP: () => t('monthsShort.month_SEP'),
    OCT: () => t('monthsShort.month_OCT'),
    NOV: () => t('monthsShort.month_NOV'),
    DEC: () => t('monthsShort.month_DEC'),
};

const WEEK_DAY_NAME_MAP: Record<WeekDaySuffix, () => string> = {
    MON: () => t('weekDays.day_MON'),
    TUE: () => t('weekDays.day_TUE'),
    WED: () => t('weekDays.day_WED'),
    THU: () => t('weekDays.day_THU'),
    FRI: () => t('weekDays.day_FRI'),
    SAT: () => t('weekDays.day_SAT'),
    SUN: () => t('weekDays.day_SUN'),
};

const SHORT_WEEK_DAY_NAME_MAP: Record<WeekDaySuffix, () => string> = {
    MON: () => t('weekDaysShort.day_MON'),
    TUE: () => t('weekDaysShort.day_TUE'),
    WED: () => t('weekDaysShort.day_WED'),
    THU: () => t('weekDaysShort.day_THU'),
    FRI: () => t('weekDaysShort.day_FRI'),
    SAT: () => t('weekDaysShort.day_SAT'),
    SUN: () => t('weekDaysShort.day_SUN'),
};

const MIN_WEEK_DAY_NAME_MAP: Record<WeekDaySuffix, () => string> = {
    MON: () => t('weekDaysMin.day_MON'),
    TUE: () => t('weekDaysMin.day_TUE'),
    WED: () => t('weekDaysMin.day_WED'),
    THU: () => t('weekDaysMin.day_THU'),
    FRI: () => t('weekDaysMin.day_FRI'),
    SAT: () => t('weekDaysMin.day_SAT'),
    SUN: () => t('weekDaysMin.day_SUN'),
};

export function getMonthSuffix(monthNumber: number): ShortMonthNames {
    return SHORT_MONTH_NAMES[monthNumber];
}

export function getMonthName(monthNumber: number): string {
    return MONTH_NAME_MAP[SHORT_MONTH_NAMES[monthNumber]]?.() || '';
}

export function getShortMonthName(monthNumber: number): string {
    return SHORT_MONTH_NAME_MAP[SHORT_MONTH_NAMES[monthNumber]]?.() || '';
}

export function getWeekDaySuffix(dayNumber: number): string {
    return WEEK_DAY_SUFFIXES[dayNumber];
}

export function getWeekDayName(dayNumber: number): string {
    return WEEK_DAY_NAME_MAP[WEEK_DAY_SUFFIXES[dayNumber]]?.() || '';
}

export function getShortWeekDayName(dayNumber: number): string {
    return SHORT_WEEK_DAY_NAME_MAP[WEEK_DAY_SUFFIXES[dayNumber]]?.() || '';
}

export function getMinWeekDayName(dayNumber: number): string {
    return MIN_WEEK_DAY_NAME_MAP[WEEK_DAY_SUFFIXES[dayNumber]]?.() || '';
}
